import {
  Avatar,
  Badge,
  Button,
  Checkbox,
  Popover,
  Space,
  TableColumnType,
  Tooltip,
} from 'antd'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { ColDef } from 'ag-grid-community'
import { DateTimeFormatSimples } from '../../../models/datetime'
import {
  getRecipeCategoryName,
  getRecipeStatusName,
} from '../../../models/recipe'
import { Checks } from '../../../models/setting'

type Action =
  | 'detail'
  | 'print'
  | 'reapply'

export const AGColumns = (
  startIndex?: any,
  onAction?: (
    action: Action,
    t: any,
  ) => void,
  columnList?: any,
  SYCKHRSJHData?: boolean,
): ColDef[] => {

  const getprescriptionSourceNmae = (prescriptionSource: any) => {
    switch (prescriptionSource) {
      case 'KJ':
        return '康久互联网处方'
      default:
        return '-'
    }
  }
  return (
    columnList?.map((item: any) => {
      // 根据注释掉的列配置，补充 cellRendererFramework 或 valueFormatter
      switch (item.field) {
        case 'index':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '41px' },
            cellRendererFramework: function IndexCellRenderer(params: any) {
              if (params.node.rowPinned) {
                return ''
              }
              return `${Number(startIndex || 0) + params.node.rowIndex + 1}`
            },
          };
        case 'patientName': //患者姓名
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '41px' },
            cellRendererFramework: function PatientNameCellRenderer(params: any) {
              const t = params.data;
              // 处理 pinned row（合计行）
              if (params.node.rowPinned) {
                return ''
              }
              return t?.patientName ? t?.patientName : '-'
            }
          };
        case 'prescriptionNo': //处方单号
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'center',
                lineHeight: '41px'
              };
            },
            cellRendererFramework: function CommonCellRenderer(params: any) {
              if (params.node.rowPinned) return '';
              return params.value || '-';
            },
          };
        case 'disease': //疾病名称
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'center',
                lineHeight: '41px'
              };
            },
            cellRendererFramework: function CommonCellRenderer(params: any) {
              if (params.node.rowPinned) return '';
              const disease = params.value?.split(',')
                .map((v: any) => {
                  const disease: any = v?.split('/')
                  return disease[0]
                })
              return disease?.join(',') || '-';
            },
          };
        case 'reason': //不通过原因
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '41px' },
            cellRendererFramework: function RejectReasonCellRenderer(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const value = params.value;
              return (
                <Tooltip title={t?.status == 2 ? value : '-'}>
                  <span style={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {t?.status == 2 ? value : '-'}
                  </span>
                </Tooltip>
              );
            },
          };
        case 'prescriptionSource': //处方来源
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '41px' },
            cellRendererFramework: function SourceCellRenderer(params: any) {
              if (params.node.rowPinned) return '';
              return getprescriptionSourceNmae(params.value) || '-';
            },
          };
        case 'recipeCategory': //处方类型
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '41px' },
            cellRendererFramework: function CategoryCellRenderer(params: any) {
              if (params.node.rowPinned) return '';
              return params.value != null ? getRecipeCategoryName(params.value) || '-' : '-';
            },
          };
        case 'status': //处方状态
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '41px' },
            cellRendererFramework: function StatusCellRenderer(params: any) {
              if (params.node.rowPinned) return '';
              const map: any = { 0: '待审核', 1: '审核通过', 2: '审核不通过' }
              if (params.value == null) return '-';
              const text = map[params.value] || '-';
              if (params.value == 2) {
                return <span style={{ color: '#f5222d' }}>{text}</span>;
              }
              return text;
            },
          };
        case 'settlementStatus': //结算状态
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '41px' },
            cellRendererFramework: function SettlementCellRenderer(params: any) {
              if (params.node.rowPinned) return '';
              if (params.value == null) return '-';
              const text = getRecipeStatusName(params.value) || '-';
              if (params.value == 5) {
                return <span style={{ color: '#f5222d' }}>{text}</span>;
              }
              return text;
            },
          };
        case 'prescribeTime': //开单时间
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '41px' },
            cellRendererFramework: function DateCellRenderer(params: any) {
              if (params.node.rowPinned) return '';
              return params.value && moment(params.value).isValid() ? moment(params.value)?.format(DateTimeFormatSimples) : '-';
            },
          };
        case 'action':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '41px' },
            cellRendererFramework: function ActionCellRenderer(params: any) {
              if (params.node.rowPinned) return '';
              const t = params.data;
              const isReject = t?.status == 2; // 审核不通过
              return (
                <>
                  <Button
                    type='link'
                    size='small'
                    onClick={() => onAction && onAction('detail', t)}
                  >
                    详情
                  </Button>
                  {isReject ? (
                    <Button
                      size='small'
                      type='link'
                      onClick={() => onAction && onAction('reapply', t)}
                    >
                      重新申请
                    </Button>
                  ) : (
                    <Button
                      size='small'
                      type='link'
                      onClick={() => onAction && onAction('print', t)}
                    >
                      打印
                    </Button>
                  )}
                </>
              );
            }
          };
        default:
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '41px' },
          };
      }
    })
  )
}

// 新老目录展示方式
export const getProcuctInfo = (item: any, settings: any) => {
  const materialsCategory = item.materialsCategory
  const packSpec = item.packSpec ? item.packSpec : '-'
  const spec = item.spec ? item.spec : '-'
  const doseCategory = item.doseCategory ? item.doseCategory : '-'
  const tenantSupplierName = item.tenantSupplierName ? item.tenantSupplierName : '-'
  const model = item.model ? item.model + '/' : ''
  const accountUnit = item.accountUnit ? item.accountUnit : '-'

  if (settings?.[Checks.MLKG] == 1) {
    if (materialsCategory == '0') {
      // 包装规格 + 剂型 
      return packSpec + '/' + doseCategory
    } else if (materialsCategory == '1' || materialsCategory == '2') {
      // 包装规格 + 型号 
      return packSpec + '/' + model
    } else {
      // 包装规格 + 生产厂家
      return packSpec + '/' + tenantSupplierName
    }
  } else {
    if (materialsCategory == '0') {
      // 规格 + 包装规格 + 包装单位（账簿单位） + 剂型 
      return spec + '/' + packSpec + '/' + accountUnit + '/' + doseCategory
    } else if (materialsCategory == '1' || materialsCategory == '2') {
      // 规格 + 包装规格 + 型号 + 包装单位（账簿单位）
      return spec + '/' + packSpec + '/' + accountUnit + '/' + model
    } else {
      // 规格 + 包装规格 + 包装单位（账簿单位）
      return spec + '/' + packSpec + '/' + accountUnit
    }
  }
}
export const Columns = (settings: any): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${index + 1}`,
    },
    {
      title: '药品名称',
      align: 'center',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '规格',
      align: 'center',
      dataIndex: 'spec',
      key: 'spec',
      // render: (_, t) => getProcuctInfo(t, settings),
      render: (_, t) => (settings?.[Checks.MLKG] == 1 ? t?.spec : t?.packSpec) || '-',
    },
    {
      title: '数量',
      align: 'center',
      key: 'drugCount',
      render: (_, t) => t.drugCount + (t?.spitTag == 1 ? t?.splitUnit : t?.accountUnit),
    },
  ]
}
